/**
 * Comment Api
 */
// 댓글 리스트
export async function getCommentList(app, mtId, clipId, cmId, lastKey) {
  return await app.$axios.post('/v1/comment/list', {
    mtId,
    clipId,
    cmId,
    lastKey,
  })
}

// Public 댓글 리스트
export async function getPublicCommentList(app, mtId, clipId, cmId, lastKey) {
  return await app.$axios.post('/v1/comment/public/list', {
    mtId,
    clipId,
    cmId,
    lastKey,
  })
}

// 댓글 작성
export async function createComment(app, mtId, clipId, parentCmId, cmContent, emailContent, boxData) {
  return await app.$axios.post('/v1/comment/create', {
    mtId,
    clipId,
    parentCmId,
    cmContent,
    emailContent,
    boxData,
  })
}

// 댓글 수정
export async function updateComment(app, mtId, cmId, cmContent) {
  return await app.$axios.post('/v1/comment/update', {
    mtId,
    cmId,
    cmContent,
  })
}

export async function deleteComment(app, mtId, cmId) {
  return await app.$axios.post('/v1/comment/delete', {
    mtId,
    cmId,
  })
}
